import React from 'react';
import PageHeader from '../../Components/PageHeader/PageHeader';

import spa1 from '../../Assets/Images/Spa.jpg'
import spa2 from '../../Assets/Images/Spa2.jpg'

const ContactUs = () => {
    return (
        <>
            <PageHeader
                title="Contact Us"
                breadcrumbs={[
                    { label: 'Home', href: '/' },
                    // { label: 'About', href: '/about' },
                    { label: 'Contact' }
                ]}
            />
            <div className="container py-5">

                <div className="bg-white border rounded mb-5">
                    <div className="row justify-content-center">
                        <img src={spa1} alt="School" />
                    </div>
                </div>


                <div className="bg-white border rounded">
                    <div className="row justify-content-center">
                        {/* Left side - Contact Details */}

                        <div className="col-md-6 d-flex justify-content-center align-items-center flex-column text-center">
                            <h5 className="fw-bold text-black">Centre of Excellence, SPA, New Delhi</h5>
                            <p className='text-black'>6-Block-B, Indraprastha Estate, New Delhi 110002</p>
                            <p className='text-black'>Ph: +91 11 - 2370 2375 , +91 11 - 2370 2376</p>
                            <p className='text-black'>Fax. 011 - 2370 2383</p>
                            <p className='text-black'>PROJECTS: <a href='#'>coeupdspad@spa.ac.in</a></p>
                            <p className='text-black'>TRAINING AND CAPACITY BUILDING: <a href='#'>coefpdpspadelhi@spa.ac.in</a></p>
                        </div>

                        {/* Right side - Google Map */}
                        <div className="col-md-6">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1845.184446835043!2d77.24457718907085!3d28.6318678820429!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390cfcd6b3b0a069%3A0x548a73acdca2eb45!2sS.P.A.%20Delhi%20Architecture%20Block!5e0!3m2!1sen!2sin!4v1750939058748!5m2!1sen!2sin"
                                width="100%"
                                height="350"
                                allowFullScreen=""
                                loading="lazy"
                                title="Google Map"
                                style={{ border: 0 }}
                            ></iframe>

                        </div>
                    </div>
                </div>

                {/* <div className="bg-danger border rounded mt-5">
                    <div className="row justify-content-center">
                        <img src={spa2} alt="School" />
                    </div>
                </div> */}

            </div >
        </>
    );
};

export default ContactUs;
